import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { DataQuery } from '../models/data-query.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';

@AutoUnsubscribe()
@Component({
    selector: 'app-data-query-unsaved-changes-dialog',
    templateUrl: './data-query-unsaved-changes-dialog.component.html',
    styleUrls: ['./data-query-unsaved-changes-dialog.component.css']
})
export class DataQueryUnsavedChangesDialogComponent implements OnInit, OnDestroy {

    // Injected Properties
    currentQuery: DataQuery;
    userCanOverwrite: boolean;
    unsavedChanges: boolean;

    // Class Functions
    constructor(
        private dialogBox: MatDialogRef<DataQueryUnsavedChangesDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any
    ) { }

    // Event Functions
    ngOnInit() {
        // PRE: injected data with the injected properties
        // POST: initializes the data
        this.currentQuery = this.data.currentQuery;
        this.userCanOverwrite = this.data.userCanOverwrite;
        this.unsavedChanges = this.data.unsavedChanges;
    }

    ngOnDestroy() {
        // NOTE: this is implemented for @AutoUnsubscribe()
    }

    cancel() {
        // PRE: the cancel button is clicked
        // POST: closes the dialog with -1
        this.dialogBox.close(-1);
    }

    continueWithoutSaving() {
        // PRE: the continue without saving button is clicked
        // POST: closes the dialog box with 0
        this.dialogBox.close(0);
    }

    saveAsNew() {
        // PRE: the save as new button is clicked
        // POST: closes the dialog box with 1
        this.dialogBox.close(1);
    }

    saveQuery() {
        // PRE: the save query button is clicked
        // POST: closes the dialog box with 2
        this.dialogBox.close(2);
    }

    // Methods
}
